<template>
	<a
		:class="{'tab-sidebar': sidebar, 'validation-error': isInvalid}"
		:aria-selected="selected"
		class="tab"
		role="tab"
		:tabindex="disableTabbing ? -1 : 0"
		@click="onSelect"
		@keydown.enter="onSelect"
		@keydown.space="onSelect"
		@contextmenu="_onContextMenu"
	>
		<slot>
			{{value}}
		</slot>

		<t-popover
			ref="contextMenu"
			closeOnClick
			closeOnRightClick
			@open="contextMenuOpen = true"
			@close="contextMenuOpen = false;"
		>
			<slot name="contextMenu"/>
		</t-popover>
	</a>
</template>

<script>
export default {
	name: 'TTab',
	inject: { setSelected: { from: 'setSelected', default: null } },
	props: {
		selected: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [ String,Object ],
			default: '',
		},
		sidebar: {
			type: Boolean,
			default: false
		},
		disableTabbing: {
			type: Boolean,
			default: false
		},
		isInvalid: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return { contextMenuOpen: false, };
	},
	methods: {
		onSelect() {
			if (this.setSelected) {
				this.setSelected(this.value);
			}

			this.$emit('selected', this.value);
		},
		_onContextMenu(event) {
			let popover = this.$refs.contextMenu;
			if (this.$scopedSlots['contextMenu'] && popover) {
				popover.open({ top: event.clientY, left: event.clientX });
				event.preventDefault();
			}
		}
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.tab {
	@extend %font-families-ui;
	@extend %text-small;
	font-weight: 600;
	user-select: none;
	padding: 0px 16px;
	margin: 0px 8px 0px 0px;
	height: 32px;
	line-height: 32px;
	box-sizing: border-box;
	display: inline-block;
	justify-content: center;
	align-items: center;
	border-radius: 3px;
	outline: none;
	cursor: pointer;

	color: get-color($text, 'default');

	&:hover {
		background-color: get-color($neutral-scale, 'N2A');
	}
	&:focus {
		box-shadow: 0 0 0 2px get-color($blue-scale, 'B5A');
	}
	&:active, &[aria-selected="true"] {

		color: get-color($text, 'selected');
		background-color: get-color($blue-scale, 'B3A');
	}
	&.tab-sidebar {
		width: 100%;
		justify-content: flex-start;
		flex: 1;
		margin-bottom: 4px;
	}

	&.validation-error {
		color: get-color($red, 'base');

		&:hover {
			background-color: get-color($red, 'lightest');
		}
		&:focus {
			box-shadow: 0 0 0 2px get-color($red, 'base');
		}
		&:active, &[aria-selected="true"] {

			color: get-color($red, 'dark');
			background-color: get-color($red, 'light');
		}
	}
}
</style>

<docs>

### Examples

#### Default
```jsx
<t-tab value="Default tab"></t-tab>
```

#### Selected
```jsx
<t-tab value="Selected" :selected="true"></t-tab>
```

</docs>
